import React from 'react'
import BuildBGCScoreBoard from 'components/ExpandedInfo/BuildBGCScoreBoard'
import BuildDueDiligenceScoreBoard from 'components/ExpandedInfo/BuildDueDiligenceScoreBoard'
import { Expansible } from 'components/Expansible'
import BgcScoreExpansibleTitle from 'components/BgcScoreExpansibleTitle'
import DDScoreExpansibleTitle from 'components/DDScoreExpansibleTitle'

function BuildScoreRelated(props) {
  const { bgcScoreBoard, ddScoreBoard } = props

  return (
    <div className="inner-spacement">
      <Expansible
        open={false}
        title={<BgcScoreExpansibleTitle finalScore={bgcScoreBoard.final_score} />}
      >
        <BuildBGCScoreBoard scoreBoardData={bgcScoreBoard} />
      </Expansible>
      <Expansible
        open={false}
        title={<DDScoreExpansibleTitle finalScore={ddScoreBoard.final_score} />}
      >
        <BuildDueDiligenceScoreBoard scoreBoardData={ddScoreBoard} />
      </Expansible>
    </div>
  )
}

export default BuildScoreRelated
